module.exports = "{{text}} <span class=\"svg-icons-wrp svg-icons-wrp_multiselect\"> <svg class=\"svg-icons svg-icons_multiselect\"><use xlink:href=#icon-checked /> </svg> </span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/multiSelect/templates/multiSelectItem.hbs
// module id = 671
// module chunks = 0